<script>
export default
{
    name: 'mv-address',

    methods:
    {
        setPlace(place)
        {
            if (place)
            {
                this.$emit('input', place.formatted_address)
                this.$emit('locationChange', [
                    place.geometry.location.lat(),
                    place.geometry.location.lng()
                ])
            }
        },
    }
}
</script>

<template>
<div>
    <gmap-autocomplete
        class="form-control"
        select-first-on-enter
        placeholder=""
        @place_changed="setPlace"
        >

    </gmap-autocomplete>
</div>
</template>


// WEBPACK FOOTER //
// src/components/Address.vue